import React, { useId } from "react";
import tampuuriWindowObject from "../../tampuuriWindowObject.js";
import accessibility from "../../accessibility.js";

const Rent = (props) => {
  const { params, submitParams } = props;
  const { translate } = tampuuriWindowObject();
  const { announceMessage, globalAccessibilitySpeakerId } = accessibility();
  const id = useId();

  const changeRent = (e) => {
    const numericValue = e?.target?.value.replace(/[^0-9]/g, "");

    if (isNaN(parseInt(numericValue)) || parseInt(numericValue) === 0) {
      submitParams({
        rent: "",
      });
      return;
    }

    submitParams({ rent: parseInt(numericValue) });
    announceMessage(
      globalAccessibilitySpeakerId,
      translate("Minimum rent") + numericValue + "€",
    );
  };

  return (
    <div className="input-wrapper max-rent">
      <label htmlFor={id}>{translate("Maximum rent € / Month")}</label>
      <input
        onChange={changeRent}
        placeholder={"Eur"}
        type="number"
        id={id}
        name="rent-end"
        value={params.rent}
      ></input>
    </div>
  );
};

export default Rent;
